export class SparkJob {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sparkEngineId",
            "baseName": "sparkEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sparkEngineName",
            "baseName": "sparkEngineName",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SparkJobStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "SparkJobRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "SparkJobStorageConfig",
            "format": ""
        },
        {
            "name": "sparkApplicationId",
            "baseName": "sparkApplicationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "attempts",
            "baseName": "attempts",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkJob.attributeTypeMap;
    }
    constructor() {
    }
}
